var _defs, _polygon, _g, _polygon2, _g2, _g3, _g4, _polygon3, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGarage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f6f6f6;\n      }\n\n      .cls-2 {\n        fill: gray;\n      }\n\n      .cls-3 {\n        fill: #6f6f6e;\n      }\n\n      .cls-4 {\n        fill: #585857;\n      }\n\n      .cls-5 {\n        fill: #c5c5c5;\n      }\n\n      .cls-6 {\n        fill: #8b7f6e;\n      }\n\n      .cls-7 {\n        fill: #5d6864;\n      }\n\n      .cls-8 {\n        fill: #ececec;\n      }\n\n      .cls-9 {\n        fill: #65635f;\n      }\n\n      .cls-10 {\n        fill: #b1b1b0;\n      }\n\n      .cls-11 {\n        fill: #222221;\n      }\n\n      .cls-12 {\n        fill: #76614a;\n      }\n\n      .cls-13 {\n        fill: #3f3e3e;\n      }\n\n      .cls-14 {\n        fill: #868686;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "485.27 770.46 60.13 637.61 600.97 542.27 1019.87 599.97 485.27 770.46"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "964.25 598.77 969.61 597.26 969.61 395.91 964.25 395.91 964.25 598.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "958.9 596.53 964.25 598.77 964.25 395.91 958.9 397.41 958.9 596.53"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "514.06 736.49 962.67 598.77 962.67 395.91 514.06 458.9 514.06 736.49"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "508.7 738 514.06 736.49 514.06 446.43 508.7 446.43 508.7 738"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "503.34 735.76 508.7 738 508.7 446.43 503.34 447.94 503.34 735.76"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "129.24 634.31 134.6 633.64 134.6 401.18 129.24 401.18 129.24 634.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "123.89 632.07 129.24 634.31 129.24 401.18 123.89 402.69 123.89 632.07"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "269.64 325.17 102.89 402.99 103.44 404.18 269.64 326.36 269.64 325.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "269.64 325.17 505.13 446.43 505.13 447.63 269.64 326.36 269.64 325.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "986.94 392.15 505.13 446.43 505.13 447.63 986.94 393.34 986.94 392.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "986.94 392.15 505.13 446.43 269.64 325.17 774.8 309.54 986.94 392.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "269.64 338.98 109.09 415 109.09 404.24 269.64 328.21 269.64 338.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "269.64 338.98 505.13 460.01 505.13 449.24 269.64 328.21 269.64 338.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "103.44 404.18 109.09 404.24 269.64 328.21 269.64 326.36 103.44 404.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "109.09 415 269.64 338.98 274.76 341.61 117.35 415 109.09 415"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "269.64 328.21 269.64 326.36 505.13 447.63 505.13 449.24 269.64 328.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "980.6 401.03 505.13 460.01 505.13 449.24 980.6 395.91 980.6 401.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "980.6 395.91 980.6 394.06 505.13 447.63 505.13 449.24 980.6 395.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "584.7 315.42 805.49 412.59 817 411.3 596.11 315.07 584.7 315.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "428.68 320.25 657.15 429.31 669.17 427.95 440.48 319.88 428.68 320.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "331.57 323.26 563.79 439.83 576.12 438.44 343.59 322.88 331.57 323.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "350.97 322.65 582.5 437.72 594.77 436.34 362.95 322.28 350.97 322.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "643.43 313.6 860.77 406.36 872.08 405.09 654.68 313.26 643.43 313.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "545.62 316.63 768.53 416.76 780.17 415.45 557.13 316.27 545.62 316.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "604.26 314.82 823.94 410.51 835.38 409.22 615.62 314.46 604.26 314.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "623.84 314.21 842.37 408.44 853.74 407.16 635.15 313.86 623.84 314.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "312.18 323.86 545.07 441.94 557.45 440.54 324.25 323.48 312.18 323.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "467.61 319.04 694.36 425.11 706.26 423.77 479.32 318.68 467.61 319.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "292.8 324.45 526.32 444.05 538.76 442.65 304.91 324.08 292.8 324.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "409.24 320.85 638.52 431.41 650.6 430.04 421.08 320.48 409.24 320.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "448.14 319.65 675.76 427.21 687.72 425.86 459.89 319.28 448.14 319.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "487.1 318.44 712.93 423.02 724.77 421.69 498.75 318.08 487.1 318.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "526.1 317.23 750.02 418.84 761.72 417.52 537.66 316.88 526.1 317.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "370.38 322.05 601.19 435.61 613.4 434.24 382.32 321.68 370.38 322.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "506.59 317.84 731.48 420.93 743.26 419.6 518.2 317.48 506.59 317.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "389.8 321.45 619.86 433.51 632.01 432.14 401.69 321.08 389.8 321.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "565.15 316.03 787.02 414.67 798.6 413.37 576.61 315.67 565.15 316.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "721.93 311.17 934.17 398.09 945.2 396.85 732.97 310.83 721.93 311.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "269.64 325.17 505.13 446.43 520.05 444.75 285.59 324.68 269.64 325.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "702.28 311.78 915.85 400.16 926.95 398.91 713.38 311.44 702.28 311.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "682.65 312.39 897.52 402.22 908.69 400.97 693.8 312.04 682.65 312.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "986.94 392.15 774.8 309.54 761.27 309.96 970.73 393.98 986.94 392.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "663.03 313 879.16 404.29 890.4 403.03 674.23 312.65 663.03 313"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "752.58 310.23 741.59 310.57 952.46 396.03 963.42 394.8 752.58 310.23"
  })))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "508.7 738 129.24 634.31 129.24 409.46 274.76 341.61 508.7 459.57 508.7 738"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "652.18 574.56 593.82 581.89 593.82 711.89 592.57 712.12 592.57 580.83 653.43 573.2 653.43 694.08 652.18 694.44 652.18 574.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "652.18 574.56 652.18 694.44 593.82 711.89 593.82 581.89 652.18 574.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "598.01 710.73 650.09 695.59 650.09 576.81 598.01 584.41 598.01 710.73"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 645.56,
    cy: 638.45,
    r: 2.31
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "722.38 643.25 722.38 560.71 698.23 563.77 698.23 649.84 722.38 643.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "695.22 646.54 695.22 564.01 698.23 563.77 698.23 649.84 695.22 646.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 719.39,
    y: 639.7,
    height: 3.35,
    transform: "translate(-215.86 874.13) rotate(-55.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "718.01 640.43 718.01 640.43 718.01 562.6 721.05 562.22 721.05 642.24 720.77 642.31 718.01 640.43 718.01 640.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "718.01 640.43 720.77 642.31 699.56 648.11 699.56 645.16 718.01 640.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "718.01 640.43 699.56 645.16 699.56 564.94 718.01 562.6 718.01 640.43 718.01 640.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "715.8 638.71 715.8 565.11 699.56 567.56 699.56 642.99 715.8 638.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "714.92 638.03 714.92 566.14 699.56 568.46 699.56 642.08 714.92 638.03"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "715.8 603.74 714.92 603.18 699.56 605.58 699.56 606.37 715.8 603.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "715.8 603.74 715.8 604.78 699.56 607.38 699.56 606.37 715.8 603.74"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "766.15 632.74 766.15 554.56 743.28 557.46 743.28 638.99 766.15 632.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "740.43 635.87 740.43 557.68 743.28 557.46 743.28 638.99 740.43 635.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 763.32,
    y: 629.38,
    height: 3.17,
    transform: "translate(-188.1 905.88) rotate(-55.69)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "762.01 630.07 762.01 630.07 762.01 556.35 764.9 555.99 764.9 631.79 764.63 631.86 762.01 630.07 762.01 630.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "762.01 630.07 764.63 631.86 744.54 637.35 744.54 634.56 762.01 630.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "762.01 630.07 744.54 634.56 744.54 558.56 762.01 556.35 762.01 630.07 762.01 630.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "759.92 628.45 759.92 558.72 744.54 561.05 744.54 632.5 759.92 628.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "759.09 627.8 759.09 559.7 744.54 561.9 744.54 631.64 759.09 627.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "759.92 595.32 759.09 594.79 744.54 597.06 744.54 597.82 759.92 595.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "759.92 595.32 759.92 596.3 744.54 598.77 744.54 597.82 759.92 595.32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarage);
export default __webpack_public_path__ + "static/media/Garage.632f6b04bc2794e77276da519c459187.svg";
export { ForwardRef as ReactComponent };